<script lang="ts">
  import Utils from "../../lib/Utils";
  import type { IS3Object } from "../../types";
  export let fileList: IS3Object[] = [];
</script>

<div class="List">
  {#each fileList as item}
    <div
      class="ListItem"
      on:click={() => {
        // window.open(BackEnd.getCaseByKeyUrl(item.Key), "S3File");
      }}
    >
      <div>{item._filename}</div>
      <div>{Utils.bytesToSize(item.Size)}</div>
      <div>{item._cat.toLocaleString()}</div>
    </div>
  {/each}
</div>

<style>
  div.List {
    border-radius: 0.5rem;
    margin-top: 1rem;
    display: block;
    border: solid 1px lightgrey;
    background-color: var(--bg-grey);
    height: 800px;
    overflow-y: auto;
    cursor: pointer;
  }
  div.List .ListItem {
    display: flex;
    background-color: white;
    align-items: stretch;
    padding-top: 1rem;
    transition: all ease-in-out 0.5s;
    margin: 0.3rem;
    border-radius: 0.2rem;
    justify-content: space-between;
  }

  div.List .ListItem:hover {
    background-color: var(--bg-blue);
    /*  background-color: rgba(0, 0, 0, 0.02);*/
    transition: all ease-in-out 0.5s;
  }

  .ListItem div {
    padding: 1rem;
    text-align: left;
  }

  .ListItem div:last-child {
    text-align: right;
    color: grey;
    font-size: 0.8rem;
    padding-right: 0.8rem;
  }
  
</style>
